/*=========================================================================================
  File Name: switches.js
  Description: Vuex store for fetching and getting switches (course, regular or department).
==========================================================================================*/
//imports
import axios from "axios";

// initial state
const state = {
  switches: [],
  courseSwitches: [],
  depSwitches: [],
  switchesByCourse: [],
};

// getters
const getters = {
  getSwitches: (state) => {
    return state.switches;
  },
  getCourseSwitches: (state) => {
    return state.courseSwitches;
  },
  getSwitchesByCourse: (state) => {
    return state.switchesByCourse;
  },
  getDepSwitches: (state) => {
    return state.depSwitches;
  },
};

// actions
const actions = {
  fetchSwitches({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .get("api/Switches")
        .then((res) => {
          setTimeout(() => resolve(res.data), 500);
          commit("FETCH_SWITCHES", res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  fetchSwitchesByMultipleCourses({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post("api/Switches/multiple", payload)
        .then((res) => {
          setTimeout(() => resolve(res.data), 500);
          commit("FETCH_SWITCHES_BY_COURSE", res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  fetchSwitchesByCourse({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .get("api/Switches/" + payload.courseId)
        .then((res) => {
          setTimeout(() => resolve(res.data), 500);
          commit("FETCH_SWITCHES_BY_COURSE", res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  fetchCourseSwitch({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .get("api/CourseSwitches/" + payload)
        .then((res) => {
          setTimeout(() => resolve(res.data), 500);
          commit("FETCH_COURSESWITCHES", res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  fetchCourseSwitches({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .get("api/CourseSwitches/")
        .then((res) => {
          setTimeout(() => resolve(res.data), 500);
          commit("FETCH_COURSESWITCHES", res.data);
        })
        .catch((err) => {
          commit("FETCH_COURSESWITCHES", []);
          reject(err);
        });
    });
  },
  addCourseSwitch({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post("api/CourseSwitches/", payload)
        .then((res) => {
          setTimeout(() => resolve(res.data), 500);
          commit("ADD_COURSESWITCHES", res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  addMultipleCourseSwitches({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post("api/CourseSwitches/multiple", payload)
        .then((res) => {
          setTimeout(() => resolve(res.data), 500);
          commit("ADD_COURSESWITCHES", res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  fetchDepartmentSwitch({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          "api/DepartmentSwitches/" +
            payload.departmentId +
            "/" +
            payload.courseId
        )
        .then((res) => {
          setTimeout(() => resolve(res.data), 500);
          commit("FETCH_DEPSWITCHES", res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  editCourseSwitch({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .put("api/CourseSwitches", payload)
        .then((res) => {
          setTimeout(() => resolve(res.data), 500);
          commit("EDIT_COURSESWITCH", res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  editMultipleCourseSwitches({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .put("api/CourseSwitches/multiple", payload)
        .then((res) => {
          setTimeout(() => resolve(res.data), 500);
          commit("EDIT_COURSESWITCH", res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  deleteCourseSwitch({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .delete("api/CourseSwitches/" + payload.courseSwitchId)
        .then((res) => {
          setTimeout(() => resolve(res.data), 500);
          commit("DELETE_COURSESWITCH", res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  deleteMultipleCourseSwitches({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .delete("api/CourseSwitches/multiple/" + payload.switch.switchId, {
          data: payload,
        })
        .then((res) => {
          setTimeout(() => resolve(res.data), 500);
          commit("DELETE_MULTIPLE_COURSESWITCH", res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  finishAllCourseSwitches({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post("api/switches/finish/" + payload.id + "/" + payload.finish)
        .then((res) => {
          setTimeout(() => resolve(res.data), 500);
          commit("FINISH_COURSESWITCHES", payload);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  fillFinishedCourseSwitches({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .get("api/Switches/addFinished/")
        .then((res) => {
          setTimeout(() => resolve(res.data), 500);
          commit("FETCH_CONTACTS", []);
        })
        .catch((err) => {
          commit("FETCH_CONTACTS", []);
          reject(err);
        });
    });
  },
};

// mutations
const mutations = {
  FETCH_SWITCHES_BY_COURSE(state, data) {
    data.forEach((element) => {
      if (element.type == "number" || element.type == "text") {
        if (element.value.length <= 0) element.value = "";
      } else if (element.type == "multiple") {
        element.courseSwitchDatas.forEach((data) => {
          data.keyValue = data.keyValue === "true";
          data.deleted = false;
        });
      } else {
        element.value = element.value === "true";
      }
    });

    state.switchesByCourse = data;
  },
  FETCH_SWITCHES(state, data) {
    state.switches = data;
  },
  FETCH_COURSESWITCHES(state, data) {
    state.courseSwitches = data;
  },
  ADD_COURSESWITCHES(state, data) {
    let newarray = reformatStringToBoolArray(
      data.concat(state.switchesByCourse)
    );
    newarray.sort((a, b) => (a.position > b.position ? 1 : -1));

    newarray.forEach((element) => {
      if (element.type == "multiple") {
        element.courseSwitchDatas = [];
      }
    });

    state.switchesByCourse = newarray;
  },
  FETCH_DEPSWITCHES(state, data) {
    state.depSwitches = data;
  },
  EDIT_COURSESWITCH(state, data) {
    console.log(data);
  },
  DELETE_COURSESWITCH(state, data) {
    let index = state.switchesByCourse.findIndex(
      (element) => element.courseSwitchId == data.id
    );

    state.switchesByCourse.splice(index, 1);
  },
  DELETE_MULTIPLE_COURSESWITCH(state, data) {
    let index = state.switchesByCourse.findIndex(
      (element) => element.switchId == data.switchId
    );

    state.switchesByCourse.splice(index, 1);
  },
  FINISH_COURSESWITCHES(state, data) {
    if (data) {
      let arrayText = state.switchesByCourse.filter((x) => x.type == "text");
      let arrayBool = state.switchesByCourse.filter((x) => x.type != "text");

      arrayBool.forEach((element) => {
        let obj = element;
        obj.value = true;
        element = obj;
      });

      arrayText.forEach((element) => {
        let obj = element;
        if (obj.value.length <= 0) obj.value = "vuller";
        element = obj;
      });

      let newarray = arrayBool.concat(arrayText);
      newarray.sort((a, b) => (a.position > b.position ? 1 : -1));

      state.switchesByCourse = newarray;
    }
  },
};

function reformatStringToBoolArray(data) {
  return data;
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
